// extracted by mini-css-extract-plugin
export var authorCard = "N_cd";
export var authorCardContent = "N_cg";
export var authorCardImage = "N_cf";
export var bottom = "N_cm";
export var description = "N_cl";
export var name = "N_cj";
export var role = "N_ck";
export var top = "N_ch";